import React from 'react';
import { getColor } from '../../../utils/helper/3d/helper';
import { CustomColors } from '../../../styles/variables';

export const Background = () => (
    <>
        <fog attach="fog" args={[CustomColors.tertiary, 0, 10]} />
        <gridHelper args={[10000, 1000, getColor('0x090C0E'), getColor('0x090C0E')]} />
    </>
);
